import React from 'react';
import { Box, Button, Flex, Spinner, Text } from '@chakra-ui/react';
import { ErrorIcon, InfoIcon, RepeatIcon } from './AdminIcon';

/** Shared, compact feedback for staff lists, searches and page data. */
export default function AdminState({ status = 'empty', title, description, onRetry, action, ...props }) {
  const isError = status === 'error';
  const isLoading = status === 'loading';
  const StateIcon = isError ? ErrorIcon : InfoIcon;
  return (
    <Flex role={isError ? 'alert' : 'status'} aria-live={isError ? 'assertive' : 'polite'}
      align="flex-start" gap={3} p={4} mb={4} borderWidth="1px" borderRadius="lg"
      borderColor={isError ? 'red.200' : 'gray.200'} bg={isError ? 'red.50' : 'white'}
      color="gray.800" flexWrap={{ base: 'wrap', md: 'nowrap' }} {...props}>
      {isLoading ? <Spinner size="sm" mt={1} color="gray.600" flexShrink={0} /> :
        <StateIcon boxSize={5} mt={0.5} color={isError ? 'red.600' : 'gray.500'} />}
      <Box flex="1" minW={0} overflowWrap="anywhere">
        <Text fontSize="sm" fontWeight="semibold">{title}</Text>
        {description && <Text fontSize="sm" color="gray.600" mt={1}>{description}</Text>}
      </Box>
      {onRetry && <Button variant="outline" size="sm" leftIcon={<RepeatIcon boxSize={4} />}
        onClick={onRetry} flexShrink={0}>Try again</Button>}
      {action}
    </Flex>
  );
}
